import TimeSelect from './src/time-select.mjs';

TimeSelect.install = (app) => {
  app.component(TimeSelect.name, TimeSelect);
};
const _TimeSelect = TimeSelect;
const ElTimeSelect = _TimeSelect;

export { ElTimeSelect, _TimeSelect as default };
//# sourceMappingURL=index.mjs.map
